import termsPaddockESEC from '../markdown/vouchers/paddock/variants/termsES_EC.md?raw'
export default {
  common: {
    MOP: 'Pide y Retira',
  },
  alertDialog: {
    mcDeliveryError: {
      body: 'Mientras tanto, puedes hacer un pedido y retirarlo en el restaurante más cercano con @:common.MOP',
    },
  },
  orders: {
    messages: {
      flexCancelledReason: {
        type: {
          FLEX_CANCELLED_REFUND:
            'Ocurrió un problema pero, ¡no te preocupes! Recibirás el reembolso en {min} o {max} días hábiles',
        },
      },
    },
  },
  vouchers: {
    paddockf1: {
      description:
        'Al hacer clic en "Volver", podrás canjear más chances si cuentas con los puntos suficientes',
      appliedCoupon: {
        title: '¡Felicitaciones! Acabas de obtener una chance para participar del sorteo',
        description:
          'El sorteo se realizará entre todos los códigos canjeados. Tu chance está asociada al código a continuación',
      },
      notification: {
        title:
          '¡Suma una chance para participar del sorteo para vivir el exclusivo Paddock Club™ Brasil enla carrera Formula 1 São Paulo Grand Prix 2025, del 7 al 9 de noviembre, para el ganador y un acompañante!',
        description:
          'Promoción válida desde el { startDate } hasta el { endDate } inclusive, únicamente mediante la aplicación McDonald’s Ecuador. Por cada { stock } puntos canjea 1 chance para participar del sorteo. Consulta las { linkTerms }',
        acceptTermsNotice: {
          title: 'Al realizar el canje, aceptas las',
          link: {
            label: 'Bases y Condiciones.',
            url: 'https://www.mcdonalds.com.ec/bases-y-condiciones-paddock2025',
          },
        },
      },
      errors: {
        noPointsAvailable: {
          description: 'Necesitás 2500 puntos para obtenerlo ¡Sigue sumando!',
        },
      },
    },
  },
  markdown: {
    vouchers: {
      paddockf1: {
        terms: termsPaddockESEC,
      },
    },
  },
}
